// extracted by mini-css-extract-plugin
export default {"confirmDuplicateModal":"confirmDuplicateModal-WtDRu","title":"title-WJ7bM","text":"text-gNGP9","header":"header-KUfvR","footer":"footer-EO82F"};